__turbopack_context__.v({
  "className": "playfair_display_90e2262-module__x06GQa__className",
});
